import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id C2A75394-FCF6-4BFB-868F-3FC14C48B6FC
 * name arrow-u-down-right
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-down-right.svg
 * tags
 */
export const ArrowUDownRightIcon = createSvgIcon(<><path d="M21.5 14.5L16 20L10.5 14.5L11.91 13.09L15 16.17V10.5C15 8 13 6 10.5 6S6 8 6 10.5V18H4V10.5C4 6.91 6.91 4 10.5 4S17 6.91 17 10.5V16.17L20.09 13.08L21.5 14.5Z" /></>, 'ArrowUDownRightIcon');
export default ArrowUDownRightIcon